export default __webpack_public_path__ + "static/media/aboutUs-3.3ffa5bdb.jpg";